/** Shared layout for the admin Fides chat panel and adjacent Vera assist slide-out. */
export const FIDES_CHAT_PANEL_LAYOUT = {
  zIndex: 1100,
  top: { xs: 72, md: 80 },
  height: { xs: 'calc(100% - 72px)', md: 'calc(100% - 80px)' },
  chatWidth: { xs: '100%', sm: 420 },
  aiAssistWidth: { xs: '100%', sm: 360 },
} as const;
